import React from 'react'
import perona from '../../../../assets/wellness/wellness-person.png'
import { FormattedMessage } from 'react-intl'

const RewardBullet = ({ title, bullets }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'flex-start' }}>
      <div style={{ fontSize: '24px', fontWeight: 'bold', color: 'var(--zls-primary-surface)', display: 'flex', alignItems: 'center' }}>
        <img src={perona} style={{ width: '30px', marginRight: '5px' }} alt='' />
      </div>
      <div style={{ color: 'var(--zls-accent-primary-color)', textAlign: 'left' }}>
        <p style={{ margin: '8px 0 0 0', fontWeight: 500 }}>
          <FormattedMessage id={title} />
        </p>
        <ul style={{ paddingLeft: '20px', margin: 0 }}>
          {bullets.map((bullet, index) => (
            <li key={index} style={{ fontWeight: 300 }}>
              <FormattedMessage id={bullet} />
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default RewardBullet
